import React from "react";
import { LoginLoding } from "../assets/index";

const LoadingSpinner = ({
  fullScreen = true,
  title = "Please wait",
  subtitle = "Loading your workspace...",
  progress = null, // Pass a number (0-100) for determinate, or null for an infinite/animated progress bar
  showGlassEffect = true,
}) => {
  // Wrapper logic for full-screen vs nested container
  const wrapperClasses = fullScreen
    ? "fixed inset-0 z-50 flex items-center justify-center w-screen h-screen"
    : "flex items-center justify-center w-full h-full min-h-[320px]";

  // Clean backdrop overlay with a subtle dark tint
  const overlayClasses = showGlassEffect
    ? "bg-slate-900/40 backdrop-blur-md"
    : "bg-slate-900/60";

  return (
    <div className={`${wrapperClasses} ${overlayClasses} transition-all duration-300 select-none`}>
      {/* Official / Modern Card Container */}
      <div className="relative flex flex-col items-center w-full max-w-xs sm:max-w-sm p-6 sm:p-8 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 shadow-[0_20px_50px_rgba(0,0,0,0.12)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.4)]">
        
        {/* Subtle Ambient Glow Behind Graphic */}
        <div className="relative flex items-center justify-center mb-6">
          <div className="absolute -inset-1.5 bg-gradient-to-r from-blue-500/20 to-indigo-500/20 rounded-full blur-lg animate-pulse" />
          
          {/* Main Graphic Container */}
          <div className="relative flex items-center justify-center w-24 h-24 rounded-xl bg-slate-50 dark:bg-slate-800/60 border border-slate-100 dark:border-slate-700/50 p-3 shadow-inner">
            <img
              src={LoginLoding}
              alt="Loading"
              className="object-contain w-full h-full animate-[pulse_2s_ease-in-out_infinite]"
            />
          </div>
        </div>

        {/* Text Details */}
        <div className="text-center w-full">
          <h3 className="text-base font-semibold text-slate-800 dark:text-slate-100 tracking-tight">
            {title}
          </h3>
          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400 font-normal">
            {subtitle}
          </p>
        </div>

        {/* Professional Loading Bar */}
        <div className="mt-6 w-full space-y-2">
          {/* Track */}
          <div className="relative w-full h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
            {progress !== null ? (
              // Determinate Progress Bar (0% - 100%)
              <div
                className="h-full bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full transition-all duration-300 ease-out"
                style={{ width: `${Math.min(Math.max(progress, 0), 100)}%` }}
              />
            ) : (
              // Indeterminate / Infinite Animated Progress Bar
              <div className="absolute inset-y-0 w-1/3 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full animate-[shimmer_1.4s_infinite_cubic-bezier(0.65,0,0.35,1)]" />
            )}
          </div>

          {/* Optional Percentage Indicator */}
          {progress !== null && (
            <div className="flex justify-end">
              <span className="text-[11px] font-medium text-slate-400 dark:text-slate-500 tabular-nums">
                {Math.round(progress)}%
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;